import React, { useState } from 'react';
import { 
    Dialog, 
    DialogTitle, 
    IconButton, 
    DialogContent, 
    TextField,
    DialogActions,
    Button
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import { SystemEvent } from '../../RemoteCommands/SystemEvent';
import { convertBase64 } from '../../utils/convertBase64';
import moment from 'moment';

type Props = {
    importSalesOpen: boolean;
    importSalesClickClose: () => void;
    importDate: Date;
}

const ImportSalesDialog:React.FC<Props> = (props) => {
    const { 
        importSalesOpen, 
        importSalesClickClose,
        importDate
    } = props;
    const [excelBase64, setExcelBase64] = useState<string | null>(null);

    const importSalesUpload = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const target = event.target as HTMLInputElement;
        const excelFile: File = (target.files as FileList)[0];
        try {
            const base64: string = await convertBase64(excelFile);
            const base64Replace = base64.replace(/^data:(.*,)?/, '');
            setExcelBase64(base64Replace);
        } catch(error) {
            console.log("error:", error);
        }
    }

    const importExcelClick = () => {
        if(excelBase64) {
            const month = Number(moment(importDate).format('M'));
            const year = Number(moment(importDate).format('YYYY'));
            SystemEvent.EventImportProjectSales(year, month, excelBase64);
        }
        importSalesClickClose();
    }

    return (
        <Dialog
            open={importSalesOpen}
            onClose={importSalesClickClose}
            fullWidth
            maxWidth="sm">
            <DialogTitle>
                <IconButton 
                    style={{ position: 'absolute', top: '5px', right: '5px' }} 
                    onClick={importSalesClickClose}>
                    <CloseIcon />
                </IconButton>
                Указать файл для импорта
            </DialogTitle>
            <DialogContent>
                <div className="importExcel">
                    <TextField
                        fullWidth  
                        variant="outlined" 
                        size="small"
                        type="file"
                        onChange={importSalesUpload}
                        autoFocus={true}
                    />
                </div>
            </DialogContent>
            <DialogActions className="pt-3 pb-4 pr-4">
                <Button 
                    variant="contained" 
                    color="primary"
                    onClick={importExcelClick}>
                    Импортировать
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ImportSalesDialog;